(() => {
  function initialize(root) {
    root.querySelectorAll('.rfa-wine').forEach(card => {
      if (card.dataset.aboutSized) return;
      const body = card.querySelector('.rfa-wine__body');
      const width = Number(card.dataset.rfaAlphaWidth);
      const height = Number(card.dataset.rfaAlphaHeight);
      if (!body || !width || !height) return;
      card.dataset.aboutSized = 'true';
      const desktop = matchMedia('(min-width: 741px)');
      const resize = () => {
        const visibleHeight = desktop.matches ? body.getBoundingClientRect().height : 220;
        card.style.setProperty('--rfa-bottle-visible-width', `${visibleHeight * width / height}px`);
      };
      new ResizeObserver(resize).observe(body);
      desktop.addEventListener('change', resize);
      resize();
    });
  }
  document.querySelectorAll('.wynch-about-editorial').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.wynch-about-editorial').forEach(initialize);
  });
})();
